module.exports = __webpack_public_path__ + "static/media/EmptyState.7d098f87.svg";